import { useCallback, useEffect, Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { IFilteredMeetingRoomList } from 'types/MeetingRoomType'
import { InputWrapper, StyledInputText } from './styled'
import meetingIcon from 'assets/icons/meeting-room-gray.svg'

interface IMeetingSearchProps {
  rooms: IFilteredMeetingRoomList[] | []
  setSearchText: Dispatch<SetStateAction<string>>
  setData: Dispatch<SetStateAction<IFilteredMeetingRoomList[] | []>>
  searchText: string
}

export default function MeetingRoomSearch({ rooms, setData, searchText, setSearchText }: IMeetingSearchProps) {
  const { t } = useTranslation()

  // Handle change event of search input
  const handleChange = (value: string) => {
    setSearchText(value)
    filterData(value)
  }

  // Filter rooms by search text
  const filterData = useCallback(
    (value: string) => {
      const includeColumns = ['name']
      const lowercasedValue = value.toLowerCase().trim()
      if (lowercasedValue === '') setData(rooms)
      else {
        const filteredData = rooms?.filter((item: IFilteredMeetingRoomList) => {
          return Object.keys(item).some((key) =>
            includeColumns.includes(key)
              ? item[key as keyof IFilteredMeetingRoomList].toString().toLowerCase().includes(lowercasedValue)
              : false
          )
        })
        setData(filteredData)
      }
    },
    [rooms, setData]
  )

  useEffect(() => {
    filterData(searchText)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rooms])

  const disabled = !rooms?.length

  return (
    <InputWrapper className="p-input-icon-left">
      <img src={meetingIcon} alt="meeting-room-search" className="input-icon" width={20} height={20} />
      <StyledInputText
        id="meeting-room-search"
        disabled={disabled}
        value={searchText}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={t('input-texts.search-meeting-room')}
      />
    </InputWrapper>
  )
}
